<ngx-avatars
	[style]="cssStyles() ?? {}"
	[round]="isRound()"
	[size]="size()"
	[name]="calculatedName()"
	[initialsSize]="charCount()"
></ngx-avatars>
